<template>
  <div>
    <div v-if="isContentReady">
      <header class="row m-team__header">
        <macro-title :title="rawTitle" add-class="m-team__title h2 font-weight-bold"></macro-title>

        <template v-if="rawGroupParsed.length !== 1">
          <template v-if="isMobileAndTouch">
            <select v-model="selectedGroup"
                    name="teamGroup"
                    id="teamGroup"
                    class="select--filter">
              <option v-for="group in filters" :value="group.term_id">{{group.name}}</option>
            </select>
          </template>
          <template v-else>
            <multiselect v-if="filters && filters.length > 0"
                         v-model="selectedObject"
                         :options="filters"
                         class="multiselect--regular multiselect--filter"
                         label="name"
                         placeholder=""
                         track-by="term_id">
              <template slot="singleLabel" slot-scope="{ option }"><span v-html="option.name"></span></template>
            </multiselect>
          </template>
        </template>
      </header>

      <div v-for="group in teamMemberSelection"
           class="m-team__group">
        <h3 class="team__category font-weight-bold" v-html="group.name"></h3>

        <div class="row row--grid">
          <div v-for="item in group.entries"
               class="col col-sm-12 col-md-6 col-lg-3 team">
            <figure class="figure figure--square" v-if="item.feature[0]">
              <div class="figure__inner">
                <picture>
                  <img :src="item.feature[0]"
                       width="360"
                       height="360"
                       class="lazyload"
                       :alt="item.post_title"
                       loading="lazy">
                </picture>
              </div>
            </figure>

            <div class="team__content">
              <p><strong class="font-color-secondary">{{item.post_title}}</strong><br><strong>{{item.job_title}}</strong></p>
              <p class="team__info-box">
                <template v-if="item.telefon">
                  T: <a :href="'tel:' + item.telefon.replace(/ /g, '')">
                  <span class="action__text">{{item.telefon}}</span>
                </a><br>
                </template>

                <template v-if="item.mobile">
                  M: <a :href="'tel:' + item.mobile.replace(/ /g, '')">
                  <span class="action__text">{{item.mobile}}</span>
                </a><br>
                </template>

                <a v-if="item.email" :href="'mailto:' + item.email">
                  <span class="action__text">{{item.email}}</span>
                </a>
                <template v-if="item.email || item.mobile || item.telefon">
                  <br>
                  <a class="action action--bordered action--bordered-small action--download action--vcard" target="_blank" :href="'/wp-json/autoag/v1/vcard/' + item.id">
                    <span class="action__text">vCard</span>
                  </a>
                </template>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <header class="row m-team__header" style="max-width: 638px">
        <content-loader
            class="m-team__title"
            :height="60"
            :width="638"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
        >

        </content-loader>
      </header>

      <div class="row row--grid">
        <content-loader
            v-for="i in 8"
            :height="608"
            :width="362"
            :speed="2"
            class="col col-sm-12 col-md-6 col-lg-3 team"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
            :key="'loader-' + i"
        >

        </content-loader>
      </div>
    </div>
  </div>
</template>

<script>
import isTouchDevice from "is-touch-device";
import isMobile from "ismobilejs";
import MacroTitle from '../MacroTitle/MacroTitle.vue';
import Multiselect from "vue-multiselect";
import { ContentLoader } from "vue-content-loader";
import {getLexicon, getPosts, getTerms} from "../rest-service/rest-service";
export default {
  name: "VTeam",
  data () {
    return {
      teamMembers: [],
      selectedGroup: -1,
      lexicon: {},
      isContentReady: false,
      selectedObject: null,
    }
  },

  components: {
    MacroTitle,
    Multiselect,
    ContentLoader
  },

  computed: {

    rawGroupParsed () {
      return JSON.parse(this.rawGroup);
    },

    rawLocationParsed () {
      return JSON.parse(this.rawLocation);
    },

    isMobileAndTouch () {
      return isTouchDevice() && isMobile(navigator.userAgent).any
    },

    filters () {
      return [{name: this.lexicon.all_employees, term_id: -1}, ...this.teamMembers]
    },

    lang () {
      return document.documentElement.lang.split('-')[0]
    },

    teamMemberSelection () {
      let temp = [];

      if (this.selectedGroup !== -1) {
        temp = [this.teamMembers.find(item => item.term_id == this.selectedGroup)]
      } else {
        temp = this.teamMembers
      }

      return temp;
    }
  },

  mounted() {

    const getGroups = () => {
      return new Promise(resolve => {
        getTerms({
          taxonomy: 'team-groups',
          suppress_filters: 0,
          lang: this.lang,
          orderby: 'menu_order',
          order: 'ASC',

        }, (response) => {
          resolve(response.data)
        })
      })
    }

    const getMembers = () => {

      const groupTaxQueryParam = {
        'taxonomy': 'team-groups',
        'field': 'term_id',
        'terms': this.rawGroupParsed
      }

      let taxQueryArray = [
        {
          'taxonomy': 'team-locations',
          'field': 'term_id',
          'terms': this.rawLocationParsed
        }
      ];


      if (this.rawGroupParsed.length > 0) {
        taxQueryArray = [...taxQueryArray, ...[groupTaxQueryParam]]
      }


      //new URLSearchParams(obj).toString();

      return new Promise(resolve => {
        getPosts({
          post_type : 'team',
          post_status : 'publish',
          posts_per_page : -1,
          orderby: 'menu_order',
          order: 'ASC',
          tax_query: taxQueryArray,
          suppress_filters: 0,
          lang: this.lang
        }, (response) => {
          resolve(response.data)
        })
      })
    }

    const getLexiconContent = () => {
      return new Promise(resolve => {
        getLexicon(this.lang,(response) => {
          resolve(response.data)
        })
      })
    }

    Promise.all([
      getGroups(),
      getMembers(),
      getLexiconContent()
    ]).then(result => {

      this.lexicon = result[2]

      const categories = result[1].map(item => item.groups).flat();

      let groupDecoded = result[0].map(item => {
        try {
          item.name = item.name.replace(/&amp;/g, '&');
        } catch (e) {

        }
        return item
      })


      if (this.rawGroupParsed.length > 0) {
        groupDecoded = groupDecoded.filter(item => this.rawGroupParsed.findIndex(cat => cat === item.term_id) > -1)
      }

      let intersection = groupDecoded.filter(x => {
        return categories.findIndex(item => item.term_id === x.term_id) > -1
      });

      intersection = intersection.map(item => {
        item.entries = result[1].filter(entry => entry.groups.findIndex(cat => cat.term_id === item.term_id) > -1)
        item.entries = item.entries.filter((v,i,a)=>a.findIndex(t=>(t.post_title === v.post_title))===i)
        return item
      }).sort((a, b) => a.order - b.order)

      this.teamMembers = intersection
      this.selectedObject = {name: this.lexicon.all_employees, term_id: -1}

      this.isContentReady = true

    })
  },


  props: {
    rawTitle: String,
    rawLocation: String,
    rawGroup: String,
  },

  watch: {
    selectedObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedGroup = this.selectedObject ? this.selectedObject.term_id : -1
      }
    }
  }
}
</script>
